import React from 'react';

import List from '@mui/material/List';
import makeStyles from '@mui/styles/makeStyles';
import { ItemMetaData } from 'layouts/Portal/menuItemsConfig';
import Permissions from 'react-redux-permissions';

import PaperContainer from '@fd/ui/Layout/PaperContainer';
import ListItemLinkButton from '@fd/ui/List/ListItemLinkButton';

export type SettingsMenuItem = ItemMetaData & {
  subtitle?: ItemMetaData['title'];
  tagText?: ItemMetaData['title'];
  isDangerZone?: boolean;
  propertyId?: string;
  propertyName?: string;
  salesChannelName?: string;
  salesChannelId?: string;
  salesChannelType?: string;
  dataFd?: string;
};

const useStyles = makeStyles(() => ({
  listItemDanger: {
    color: '#ff426a',
  },
}));

const renderListItem = (
  item: SettingsMenuItem,
  shouldShowAsLast: boolean,
  classes: Record<string, string>
) => {
  const listItem = (
    <ListItemLinkButton
      key={item.path}
      title={item.title}
      subtitle={item.subtitle}
      iconComponent={item.icon}
      link={item.path}
      tagText={item.tagText}
      isLast={shouldShowAsLast}
      dataFd={item.dataFd}
      classesFromParent={
        item.isDangerZone
          ? {
              logo: classes.listItemDanger,
              primary: classes.listItemDanger,
              secondary: classes.listItemDanger,
            }
          : undefined
      }
    />
  );

  if (item.permissions) {
    return (
      <Permissions key={item.path} allowed={item.permissions}>
        {listItem}
      </Permissions>
    );
  }

  return listItem;
};

const SettingsList = ({
  menuItems,
  shouldShowAsLast,
}: {
  menuItems: SettingsMenuItem[];
  shouldShowAsLast?: (item: SettingsMenuItem, index: number) => boolean;
}) => {
  const classes = useStyles();
  return (
    <PaperContainer fluid>
      <List data-fd="settings-list">
        {menuItems.map((item, index) => {
          const isLast = shouldShowAsLast
            ? shouldShowAsLast(item, index)
            : index === menuItems.length - 1;
          return renderListItem(item, isLast, classes);
        })}
      </List>
    </PaperContainer>
  );
};

export default SettingsList;
